import React from 'react';
import SEOHead from '../components/SEOHead';

const TestHome = () => {
  return (
    <div style={{ padding: '20px', backgroundColor: 'white', color: 'black' }}>
      <SEOHead 
        title="Test Page - BrixBot"
        description="BrixBot test page"
        isIndexable={false}
      />
      <h1 style={{ color: 'red', fontSize: '48px' }}>BrixBot Test Page</h1>
      <p style={{ fontSize: '24px', color: 'blue' }}>This is a test to see if React is rendering properly</p>
      <button style={{ 
        padding: '10px 20px', 
        backgroundColor: 'green', 
        color: 'white', 
        border: 'none',
        fontSize: '18px'
      }}>
        Test Button
      </button>
    </div>
  );
};

export default TestHome;